

const ProductDetails=[

{
    name : "corolla",
    maker: "toyota",
    quantity: 2

},

{
    name : "civic",
    maker: "honda",

    quantity: 3
    
},



{
    name : "cultus",
    maker: "5",
    quantity: 5
    
}
]

export function itemdetails(){return ProductDetails;}